import { atom, useAtom } from 'jotai';

const archiveVaultDialogAtom = atom<string>('');

export const useArchiveVaultDialog = () => {
  const [idArchiveVaultDialogOpen, setArchiveVaultDialogOpen] = useAtom(archiveVaultDialogAtom);

  return {
    idArchiveVaultDialogOpen,
    setArchiveVaultDialogOpen,
  };
};
